import { MutationTree } from "vuex";
import { ClientsState } from "./types";

export enum SessionMutations {
  SET_REFRESH = "SET_REFRESH",
}

export const mutations: MutationTree<ClientsState> = {
  [SessionMutations.SET_REFRESH](state, payload: boolean) {
    state.refresh = payload;
  },
};
